let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iRAkb")).then(() => parcelRequire('Rs7gs'));